import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { addPhoto } from "../../lib/firebase/firestore";
import { Photo } from "../../types";
import styles from "../../styles/AddPhotoGalleryPage.module.css";

export const AddPhotoGalleryPage = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [tags, setTags] = useState("");
  const [year, setYear] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!imageUrl) return alert("Please enter an image URL");

    setLoading(true);
    try {
      const newPhoto: Omit<Photo, "id"> = {
        title,
        description,
        imageUrl,
        tags: tags.split(",").map((t) => t.trim()),
        year: parseInt(year) || undefined,
      };

      await addPhoto(newPhoto);
      alert("Photo added successfully!");
      navigate("/admin/photos");
    } catch (error) {
      console.error(error);
      alert("Failed to add photo");
    }
    setLoading(false);
  };

  return (
    <div className={styles.container}>
      <h2>Add New Photo</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
        <textarea
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <input
          type="text"
          placeholder="Tags (comma-separated)"
          value={tags}
          onChange={(e) => setTags(e.target.value)}
        />
        <input
          type="number"
          placeholder="Year"
          value={year}
          onChange={(e) => setYear(e.target.value)}
        />
        <input
          type="url"
          placeholder="Image URL"
          value={imageUrl}
          onChange={(e) => setImageUrl(e.target.value)}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? "Saving..." : "Save Photo"}
        </button>
      </form>
    </div>
  );
};
